import { render, staticRenderFns } from "./loadingAnimaton.vue?vue&type=template&id=12ac6593&"
import script from "./loadingAnimaton.vue?vue&type=script&lang=ts&"
export * from "./loadingAnimaton.vue?vue&type=script&lang=ts&"
import style0 from "./loadingAnimaton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports